import React from "react";

export default function About() {
    return (
        <div>
            <div className="container about">
                <h2>About Me</h2>
                <p>
                    I am Samuel Joseph, a front-end developer. Do you just read
                    that? Oh! Yea, I'm really cool in developing website, web
                    App. I attain my National Diploma (ND) at Federal
                    Polytechnic, Ilaro. I am so confident that my education and
                    experience make me the right person for your job. Why do I
                    say so? What I'm trying to imply is that you really need a{" "}
                    <strong>DOPE</strong> website or web App that will attract
                    people to patronize you. Trust me, you will like it when I'm
                    done with your work.
                </p>
                <p>
                    I thrive on new challenges, and my innovative approach also
                    with my desire to learn will prove to be the asset to my
                    clients. I look forward to a personal contact with you on
                    how to get your job done easier.
                </p>
            </div>
        </div>
    );
}
